import { c as _c } from "react-compiler-runtime";
import React from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import useAdobeTarget from '@nike/shop-apis/adobe-target/use-query';
import CartItemAddedModalActions from './CartItemAddedModalActions';
import CartItemAddedModalProductSize from './CartItemAddedModalProductSize';
import CartItemPrice from './CartItemPrice';
import { MINI_BAG_AT_ACTIVITY_NAME, MINI_BAG_AT_EXPERIENCES, MINI_BAG_AT_LOCATION_NAME } from './mini-bag-analytics';
import ProductAddedModal from "../base/ProductAddedModal";
var CartItemAddedModal = function CartItemAddedModal() {
  var $ = _c(6);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      stringKey: "wishlist.addedToCart",
      primaryValue: "Added to Bag",
      description: "Added to Cart Styling Moment"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var addedToCartTitle = useI18nString(t0);
  var t1;
  if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      activityName: MINI_BAG_AT_ACTIVITY_NAME,
      experiences: MINI_BAG_AT_EXPERIENCES,
      locationName: MINI_BAG_AT_LOCATION_NAME
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var _useAdobeTarget = useAdobeTarget(t1),
    experience = _useAdobeTarget.experience;
  var isMiniBagSubtotalVariant = experience === "B" || experience === "C";
  var t2;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/React.createElement(CartItemAddedModalActions, null);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  var t3;
  if ($[3] !== addedToCartTitle || $[4] !== isMiniBagSubtotalVariant) {
    t3 = /*#__PURE__*/React.createElement(ProductAddedModal, {
      title: addedToCartTitle,
      ActionsSlot: t2,
      ProductSizeComponent: CartItemAddedModalProductSize,
      PriceComponent: CartItemPrice,
      shouldScrollToTopOnOpen: true,
      isMiniBagSubtotalVariant: isMiniBagSubtotalVariant
    });
    $[3] = addedToCartTitle;
    $[4] = isMiniBagSubtotalVariant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default CartItemAddedModal;